import { render, staticRenderFns } from "./stationClamp_WINCC.vue?vue&type=template&id=4b44b5bb&scoped=true"
import script from "./stationClamp_WINCC.vue?vue&type=script&lang=js"
export * from "./stationClamp_WINCC.vue?vue&type=script&lang=js"
import style0 from "./stationClamp_WINCC.vue?vue&type=style&index=0&id=4b44b5bb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b44b5bb",
  null
  
)

export default component.exports